/*
 * GENERATED FILE -- DO NOT EDIT BY HAND.
 *
 * Produced by backend/tools/gen_meshtastic_schema.py by walking the REAL
 * meshtastic protobuf descriptors (config_pb2.Config, module_config_pb2.ModuleConfig,
 * channel_pb2.ChannelSettings, channel_pb2.Channel) -- not hand-transcribed.
 *
 * Source meshtastic package version: 2.7.11
 * (must match the pin in backend/pyproject.toml; the generator refuses to
 * run otherwise, so this version and that pin can never silently drift.)
 *
 * Regenerate with (from the repo root):
 *   docker exec -i amalgamesh-backend python - < backend/tools/gen_meshtastic_schema.py > frontend/src/lib/meshtasticSchema.generated.ts
 *
 * Enum key qualification rule:
 *   Enum types are keyed in MESHTASTIC_ENUMS by their bare protobuf short
 *   name (e.g. "RegionCode") EXCEPT when two distinct enum types share the
 *   same short name, detected generically at generation time (not
 *   hardcoded). A colliding short name is qualified as
 *   "<ParentMessageName>_<ShortName>" for every enum in the collision, so
 *   e.g. "Role" becomes "DeviceConfig_Role" and "Channel_Role" -- see
 *   below for the collisions found in this run. A field's "enumType"
 *   always points at the exact key actually used in MESHTASTIC_ENUMS.
 *
 * Collisions detected in this run (1):
 *   - 'Role': meshtastic.protobuf.Channel.Role, meshtastic.protobuf.Config.DeviceConfig.Role
 *
 * Counts (this run): 26 exported enum keys covering
 * 26 enum entries; 234 total scalar/enum/message
 * field descriptors across all sections.
 * Per-config-section field counts: device=12, position=13, power=9, network=10, display=14, lora=20, bluetooth=3, security=7, sessionkey=0, device_ui=19
 * Per-module-section field counts: mqtt=11, serial=8, external_notification=15, store_forward=6, range_test=4, telemetry=15, canned_message=11, audio=7, remote_hardware=3, neighbor_info=3, ambient_lighting=5, detection_sensor=8, paxcounter=4, statusmessage=1, traffic_management=14, tak=2
 * Channel field count: 10
 */

export type MeshtasticFieldKind =
  | "bool"
  | "int"
  | "uint"
  | "float"
  | "string"
  | "bytes"
  | "enum"
  | "message";

export interface MeshtasticEnumValue {
  readonly name: string;
  readonly value: number;
}

export interface MeshtasticField {
  readonly name: string;
  readonly jsonName: string;
  readonly kind: MeshtasticFieldKind;
  readonly repeated: boolean;
  readonly enumType?: string;
  readonly messageType?: string;
  readonly min?: number;
  readonly max?: number;
}

export const MESHTASTIC_ENUMS: Readonly<Record<string, readonly MeshtasticEnumValue[]>> = {
  "DeviceConfig_Role": [
    {
      "name": "CLIENT",
      "value": 0
    },
    {
      "name": "CLIENT_MUTE",
      "value": 1
    },
    {
      "name": "ROUTER",
      "value": 2
    },
    {
      "name": "ROUTER_CLIENT",
      "value": 3
    },
    {
      "name": "REPEATER",
      "value": 4
    },
    {
      "name": "TRACKER",
      "value": 5
    },
    {
      "name": "SENSOR",
      "value": 6
    },
    {
      "name": "TAK",
      "value": 7
    },
    {
      "name": "CLIENT_HIDDEN",
      "value": 8
    },
    {
      "name": "LOST_AND_FOUND",
      "value": 9
    },
    {
      "name": "TAK_TRACKER",
      "value": 10
    },
    {
      "name": "ROUTER_LATE",
      "value": 11
    },
    {
      "name": "CLIENT_BASE",
      "value": 12
    }
  ],
  "RebroadcastMode": [
    {
      "name": "ALL",
      "value": 0
    },
    {
      "name": "ALL_SKIP_DECODING",
      "value": 1
    },
    {
      "name": "LOCAL_ONLY",
      "value": 2
    },
    {
      "name": "KNOWN_ONLY",
      "value": 3
    },
    {
      "name": "NONE",
      "value": 4
    },
    {
      "name": "CORE_PORTNUMS_ONLY",
      "value": 5
    }
  ],
  "BuzzerMode": [
    {
      "name": "ALL_ENABLED",
      "value": 0
    },
    {
      "name": "DISABLED",
      "value": 1
    },
    {
      "name": "NOTIFICATIONS_ONLY",
      "value": 2
    },
    {
      "name": "SYSTEM_ONLY",
      "value": 3
    },
    {
      "name": "DIRECT_MSG_ONLY",
      "value": 4
    }
  ],
  "GpsMode": [
    {
      "name": "DISABLED",
      "value": 0
    },
    {
      "name": "ENABLED",
      "value": 1
    },
    {
      "name": "NOT_PRESENT",
      "value": 2
    }
  ],
  "AddressMode": [
    {
      "name": "DHCP",
      "value": 0
    },
    {
      "name": "STATIC",
      "value": 1
    }
  ],
  "DeprecatedGpsCoordinateFormat": [
    {
      "name": "UNUSED",
      "value": 0
    }
  ],
  "DisplayUnits": [
    {
      "name": "METRIC",
      "value": 0
    },
    {
      "name": "IMPERIAL",
      "value": 1
    }
  ],
  "OledType": [
    {
      "name": "OLED_AUTO",
      "value": 0
    },
    {
      "name": "OLED_SSD1306",
      "value": 1
    },
    {
      "name": "OLED_SH1106",
      "value": 2
    },
    {
      "name": "OLED_SH1107",
      "value": 3
    },
    {
      "name": "OLED_SH1107_128_128",
      "value": 4
    },
    {
      "name": "OLED_SH1107_ROTATED",
      "value": 5
    }
  ],
  "DisplayMode": [
    {
      "name": "DEFAULT",
      "value": 0
    },
    {
      "name": "TWOCOLOR",
      "value": 1
    },
    {
      "name": "INVERTED",
      "value": 2
    },
    {
      "name": "COLOR",
      "value": 3
    }
  ],
  "CompassOrientation": [
    {
      "name": "DEGREES_0",
      "value": 0
    },
    {
      "name": "DEGREES_90",
      "value": 1
    },
    {
      "name": "DEGREES_180",
      "value": 2
    },
    {
      "name": "DEGREES_270",
      "value": 3
    },
    {
      "name": "DEGREES_0_INVERTED",
      "value": 4
    },
    {
      "name": "DEGREES_90_INVERTED",
      "value": 5
    },
    {
      "name": "DEGREES_180_INVERTED",
      "value": 6
    },
    {
      "name": "DEGREES_270_INVERTED",
      "value": 7
    }
  ],
  "ModemPreset": [
    {
      "name": "LONG_FAST",
      "value": 0
    },
    {
      "name": "LONG_SLOW",
      "value": 1
    },
    {
      "name": "VERY_LONG_SLOW",
      "value": 2
    },
    {
      "name": "MEDIUM_SLOW",
      "value": 3
    },
    {
      "name": "MEDIUM_FAST",
      "value": 4
    },
    {
      "name": "SHORT_SLOW",
      "value": 5
    },
    {
      "name": "SHORT_FAST",
      "value": 6
    },
    {
      "name": "LONG_MODERATE",
      "value": 7
    },
    {
      "name": "SHORT_TURBO",
      "value": 8
    },
    {
      "name": "LONG_TURBO",
      "value": 9
    },
    {
      "name": "LITE_FAST",
      "value": 10
    },
    {
      "name": "LITE_SLOW",
      "value": 11
    },
    {
      "name": "NARROW_FAST",
      "value": 12
    },
    {
      "name": "NARROW_SLOW",
      "value": 13
    }
  ],
  "RegionCode": [
    {
      "name": "UNSET",
      "value": 0
    },
    {
      "name": "US",
      "value": 1
    },
    {
      "name": "EU_433",
      "value": 2
    },
    {
      "name": "EU_868",
      "value": 3
    },
    {
      "name": "CN",
      "value": 4
    },
    {
      "name": "JP",
      "value": 5
    },
    {
      "name": "ANZ",
      "value": 6
    },
    {
      "name": "KR",
      "value": 7
    },
    {
      "name": "TW",
      "value": 8
    },
    {
      "name": "RU",
      "value": 9
    },
    {
      "name": "IN",
      "value": 10
    },
    {
      "name": "NZ_865",
      "value": 11
    },
    {
      "name": "TH",
      "value": 12
    },
    {
      "name": "LORA_24",
      "value": 13
    },
    {
      "name": "UA_433",
      "value": 14
    },
    {
      "name": "UA_868",
      "value": 15
    },
    {
      "name": "MY_433",
      "value": 16
    },
    {
      "name": "MY_919",
      "value": 17
    },
    {
      "name": "SG_923",
      "value": 18
    },
    {
      "name": "PH_433",
      "value": 19
    },
    {
      "name": "PH_868",
      "value": 20
    },
    {
      "name": "PH_915",
      "value": 21
    },
    {
      "name": "ANZ_433",
      "value": 22
    },
    {
      "name": "KZ_433",
      "value": 23
    },
    {
      "name": "KZ_863",
      "value": 24
    },
    {
      "name": "NP_865",
      "value": 25
    },
    {
      "name": "BR_902",
      "value": 26
    },
    {
      "name": "ITU1_2M",
      "value": 27
    },
    {
      "name": "ITU2_2M",
      "value": 28
    },
    {
      "name": "EU_866",
      "value": 29
    },
    {
      "name": "EU_874",
      "value": 30
    },
    {
      "name": "EU_917",
      "value": 31
    },
    {
      "name": "EU_N_868",
      "value": 32
    },
    {
      "name": "ITU3_2M",
      "value": 33
    }
  ],
  "FEM_LNA_Mode": [
    {
      "name": "DISABLED",
      "value": 0
    },
    {
      "name": "ENABLED",
      "value": 1
    },
    {
      "name": "NOT_PRESENT",
      "value": 2
    }
  ],
  "PairingMode": [
    {
      "name": "RANDOM_PIN",
      "value": 0
    },
    {
      "name": "FIXED_PIN",
      "value": 1
    },
    {
      "name": "NO_PIN",
      "value": 2
    }
  ],
  "Theme": [
    {
      "name": "DARK",
      "value": 0
    },
    {
      "name": "LIGHT",
      "value": 1
    },
    {
      "name": "RED",
      "value": 2
    }
  ],
  "Language": [
    {
      "name": "ENGLISH",
      "value": 0
    },
    {
      "name": "FRENCH",
      "value": 1
    },
    {
      "name": "GERMAN",
      "value": 2
    },
    {
      "name": "ITALIAN",
      "value": 3
    },
    {
      "name": "PORTUGUESE",
      "value": 4
    },
    {
      "name": "SPANISH",
      "value": 5
    },
    {
      "name": "SWEDISH",
      "value": 6
    },
    {
      "name": "FINNISH",
      "value": 7
    },
    {
      "name": "POLISH",
      "value": 8
    },
    {
      "name": "TURKISH",
      "value": 9
    },
    {
      "name": "SERBIAN",
      "value": 10
    },
    {
      "name": "RUSSIAN",
      "value": 11
    },
    {
      "name": "DUTCH",
      "value": 12
    },
    {
      "name": "GREEK",
      "value": 13
    },
    {
      "name": "NORWEGIAN",
      "value": 14
    },
    {
      "name": "SLOVENIAN",
      "value": 15
    },
    {
      "name": "UKRAINIAN",
      "value": 16
    },
    {
      "name": "BULGARIAN",
      "value": 17
    },
    {
      "name": "CZECH",
      "value": 18
    },
    {
      "name": "DANISH",
      "value": 19
    },
    {
      "name": "SIMPLIFIED_CHINESE",
      "value": 30
    },
    {
      "name": "TRADITIONAL_CHINESE",
      "value": 31
    }
  ],
  "CompassMode": [
    {
      "name": "DYNAMIC",
      "value": 0
    },
    {
      "name": "FIXED_RING",
      "value": 1
    },
    {
      "name": "FREEZE_HEADING",
      "value": 2
    }
  ],
  "GpsCoordinateFormat": [
    {
      "name": "DEC",
      "value": 0
    },
    {
      "name": "DMS",
      "value": 1
    },
    {
      "name": "UTM",
      "value": 2
    },
    {
      "name": "MGRS",
      "value": 3
    },
    {
      "name": "OLC",
      "value": 4
    },
    {
      "name": "OSGR",
      "value": 5
    },
    {
      "name": "MLS",
      "value": 6
    }
  ],
  "Serial_Baud": [
    {
      "name": "BAUD_DEFAULT",
      "value": 0
    },
    {
      "name": "BAUD_110",
      "value": 1
    },
    {
      "name": "BAUD_300",
      "value": 2
    },
    {
      "name": "BAUD_600",
      "value": 3
    },
    {
      "name": "BAUD_1200",
      "value": 4
    },
    {
      "name": "BAUD_2400",
      "value": 5
    },
    {
      "name": "BAUD_4800",
      "value": 6
    },
    {
      "name": "BAUD_9600",
      "value": 7
    },
    {
      "name": "BAUD_19200",
      "value": 8
    },
    {
      "name": "BAUD_38400",
      "value": 9
    },
    {
      "name": "BAUD_57600",
      "value": 10
    },
    {
      "name": "BAUD_115200",
      "value": 11
    },
    {
      "name": "BAUD_230400",
      "value": 12
    },
    {
      "name": "BAUD_460800",
      "value": 13
    },
    {
      "name": "BAUD_576000",
      "value": 14
    },
    {
      "name": "BAUD_921600",
      "value": 15
    }
  ],
  "Serial_Mode": [
    {
      "name": "DEFAULT",
      "value": 0
    },
    {
      "name": "SIMPLE",
      "value": 1
    },
    {
      "name": "PROTO",
      "value": 2
    },
    {
      "name": "TEXTMSG",
      "value": 3
    },
    {
      "name": "NMEA",
      "value": 4
    },
    {
      "name": "CALTOPO",
      "value": 5
    },
    {
      "name": "WS85",
      "value": 6
    },
    {
      "name": "VE_DIRECT",
      "value": 7
    },
    {
      "name": "MS_CONFIG",
      "value": 8
    },
    {
      "name": "LOG",
      "value": 9
    },
    {
      "name": "LOGTEXT",
      "value": 10
    }
  ],
  "InputEventChar": [
    {
      "name": "NONE",
      "value": 0
    },
    {
      "name": "UP",
      "value": 17
    },
    {
      "name": "DOWN",
      "value": 18
    },
    {
      "name": "LEFT",
      "value": 19
    },
    {
      "name": "RIGHT",
      "value": 20
    },
    {
      "name": "SELECT",
      "value": 10
    },
    {
      "name": "BACK",
      "value": 27
    },
    {
      "name": "CANCEL",
      "value": 24
    }
  ],
  "Audio_Baud": [
    {
      "name": "CODEC2_DEFAULT",
      "value": 0
    },
    {
      "name": "CODEC2_3200",
      "value": 1
    },
    {
      "name": "CODEC2_2400",
      "value": 2
    },
    {
      "name": "CODEC2_1600",
      "value": 3
    },
    {
      "name": "CODEC2_1400",
      "value": 4
    },
    {
      "name": "CODEC2_1300",
      "value": 5
    },
    {
      "name": "CODEC2_1200",
      "value": 6
    },
    {
      "name": "CODEC2_700",
      "value": 7
    },
    {
      "name": "CODEC2_700B",
      "value": 8
    }
  ],
  "TriggerType": [
    {
      "name": "LOGIC_LOW",
      "value": 0
    },
    {
      "name": "LOGIC_HIGH",
      "value": 1
    },
    {
      "name": "FALLING_EDGE",
      "value": 2
    },
    {
      "name": "RISING_EDGE",
      "value": 3
    },
    {
      "name": "EITHER_EDGE_ACTIVE_LOW",
      "value": 4
    },
    {
      "name": "EITHER_EDGE_ACTIVE_HIGH",
      "value": 5
    }
  ],
  "Team": [
    {
      "name": "Unspecifed_Color",
      "value": 0
    },
    {
      "name": "White",
      "value": 1
    },
    {
      "name": "Yellow",
      "value": 2
    },
    {
      "name": "Orange",
      "value": 3
    },
    {
      "name": "Magenta",
      "value": 4
    },
    {
      "name": "Red",
      "value": 5
    },
    {
      "name": "Maroon",
      "value": 6
    },
    {
      "name": "Purple",
      "value": 7
    },
    {
      "name": "Dark_Blue",
      "value": 8
    },
    {
      "name": "Blue",
      "value": 9
    },
    {
      "name": "Cyan",
      "value": 10
    },
    {
      "name": "Teal",
      "value": 11
    },
    {
      "name": "Green",
      "value": 12
    },
    {
      "name": "Dark_Green",
      "value": 13
    },
    {
      "name": "Brown",
      "value": 14
    }
  ],
  "MemberRole": [
    {
      "name": "Unspecifed",
      "value": 0
    },
    {
      "name": "TeamMember",
      "value": 1
    },
    {
      "name": "TeamLead",
      "value": 2
    },
    {
      "name": "HQ",
      "value": 3
    },
    {
      "name": "Sniper",
      "value": 4
    },
    {
      "name": "Medic",
      "value": 5
    },
    {
      "name": "ForwardObserver",
      "value": 6
    },
    {
      "name": "RTO",
      "value": 7
    },
    {
      "name": "K9",
      "value": 8
    }
  ],
  "Channel_Role": [
    {
      "name": "DISABLED",
      "value": 0
    },
    {
      "name": "PRIMARY",
      "value": 1
    },
    {
      "name": "SECONDARY",
      "value": 2
    }
  ]
};

export const MESHTASTIC_CONFIG_SECTIONS: Readonly<Record<string, readonly MeshtasticField[]>> = {
  "device": [
    {
      "name": "role",
      "jsonName": "role",
      "kind": "enum",
      "repeated": false,
      "enumType": "DeviceConfig_Role"
    },
    {
      "name": "serial_enabled",
      "jsonName": "serialEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "button_gpio",
      "jsonName": "buttonGpio",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "buzzer_gpio",
      "jsonName": "buzzerGpio",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "rebroadcast_mode",
      "jsonName": "rebroadcastMode",
      "kind": "enum",
      "repeated": false,
      "enumType": "RebroadcastMode"
    },
    {
      "name": "node_info_broadcast_secs",
      "jsonName": "nodeInfoBroadcastSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "double_tap_as_button_press",
      "jsonName": "doubleTapAsButtonPress",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "is_managed",
      "jsonName": "isManaged",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "disable_triple_click",
      "jsonName": "disableTripleClick",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "tzdef",
      "jsonName": "tzdef",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "led_heartbeat_disabled",
      "jsonName": "ledHeartbeatDisabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "buzzer_mode",
      "jsonName": "buzzerMode",
      "kind": "enum",
      "repeated": false,
      "enumType": "BuzzerMode"
    }
  ],
  "position": [
    {
      "name": "position_broadcast_secs",
      "jsonName": "positionBroadcastSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "position_broadcast_smart_enabled",
      "jsonName": "positionBroadcastSmartEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "fixed_position",
      "jsonName": "fixedPosition",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "gps_enabled",
      "jsonName": "gpsEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "gps_update_interval",
      "jsonName": "gpsUpdateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "gps_attempt_time",
      "jsonName": "gpsAttemptTime",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "position_flags",
      "jsonName": "positionFlags",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "rx_gpio",
      "jsonName": "rxGpio",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "tx_gpio",
      "jsonName": "txGpio",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "broadcast_smart_minimum_distance",
      "jsonName": "broadcastSmartMinimumDistance",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "broadcast_smart_minimum_interval_secs",
      "jsonName": "broadcastSmartMinimumIntervalSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "gps_en_gpio",
      "jsonName": "gpsEnGpio",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "gps_mode",
      "jsonName": "gpsMode",
      "kind": "enum",
      "repeated": false,
      "enumType": "GpsMode"
    }
  ],
  "power": [
    {
      "name": "is_power_saving",
      "jsonName": "isPowerSaving",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "on_battery_shutdown_after_secs",
      "jsonName": "onBatteryShutdownAfterSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "adc_multiplier_override",
      "jsonName": "adcMultiplierOverride",
      "kind": "float",
      "repeated": false
    },
    {
      "name": "wait_bluetooth_secs",
      "jsonName": "waitBluetoothSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "sds_secs",
      "jsonName": "sdsSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "ls_secs",
      "jsonName": "lsSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "min_wake_secs",
      "jsonName": "minWakeSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "device_battery_ina_address",
      "jsonName": "deviceBatteryInaAddress",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "powermon_enables",
      "jsonName": "powermonEnables",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 18446744073709551615
    }
  ],
  "network": [
    {
      "name": "wifi_enabled",
      "jsonName": "wifiEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "wifi_ssid",
      "jsonName": "wifiSsid",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "wifi_psk",
      "jsonName": "wifiPsk",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "ntp_server",
      "jsonName": "ntpServer",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "eth_enabled",
      "jsonName": "ethEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "address_mode",
      "jsonName": "addressMode",
      "kind": "enum",
      "repeated": false,
      "enumType": "AddressMode"
    },
    {
      "name": "ipv4_config",
      "jsonName": "ipv4Config",
      "kind": "message",
      "repeated": false,
      "messageType": "IpV4Config"
    },
    {
      "name": "rsyslog_server",
      "jsonName": "rsyslogServer",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "enabled_protocols",
      "jsonName": "enabledProtocols",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "ipv6_enabled",
      "jsonName": "ipv6Enabled",
      "kind": "bool",
      "repeated": false
    }
  ],
  "display": [
    {
      "name": "screen_on_secs",
      "jsonName": "screenOnSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "gps_format",
      "jsonName": "gpsFormat",
      "kind": "enum",
      "repeated": false,
      "enumType": "DeprecatedGpsCoordinateFormat"
    },
    {
      "name": "auto_screen_carousel_secs",
      "jsonName": "autoScreenCarouselSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "compass_north_top",
      "jsonName": "compassNorthTop",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "flip_screen",
      "jsonName": "flipScreen",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "units",
      "jsonName": "units",
      "kind": "enum",
      "repeated": false,
      "enumType": "DisplayUnits"
    },
    {
      "name": "oled",
      "jsonName": "oled",
      "kind": "enum",
      "repeated": false,
      "enumType": "OledType"
    },
    {
      "name": "displaymode",
      "jsonName": "displaymode",
      "kind": "enum",
      "repeated": false,
      "enumType": "DisplayMode"
    },
    {
      "name": "heading_bold",
      "jsonName": "headingBold",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "wake_on_tap_or_motion",
      "jsonName": "wakeOnTapOrMotion",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "compass_orientation",
      "jsonName": "compassOrientation",
      "kind": "enum",
      "repeated": false,
      "enumType": "CompassOrientation"
    },
    {
      "name": "use_12h_clock",
      "jsonName": "use12hClock",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "use_long_node_name",
      "jsonName": "useLongNodeName",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "enable_message_bubbles",
      "jsonName": "enableMessageBubbles",
      "kind": "bool",
      "repeated": false
    }
  ],
  "lora": [
    {
      "name": "use_preset",
      "jsonName": "usePreset",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "modem_preset",
      "jsonName": "modemPreset",
      "kind": "enum",
      "repeated": false,
      "enumType": "ModemPreset"
    },
    {
      "name": "bandwidth",
      "jsonName": "bandwidth",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "spread_factor",
      "jsonName": "spreadFactor",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "coding_rate",
      "jsonName": "codingRate",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "frequency_offset",
      "jsonName": "frequencyOffset",
      "kind": "float",
      "repeated": false
    },
    {
      "name": "region",
      "jsonName": "region",
      "kind": "enum",
      "repeated": false,
      "enumType": "RegionCode"
    },
    {
      "name": "hop_limit",
      "jsonName": "hopLimit",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "tx_enabled",
      "jsonName": "txEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "tx_power",
      "jsonName": "txPower",
      "kind": "int",
      "repeated": false,
      "min": -2147483648,
      "max": 2147483647
    },
    {
      "name": "channel_num",
      "jsonName": "channelNum",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "override_duty_cycle",
      "jsonName": "overrideDutyCycle",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "sx126x_rx_boosted_gain",
      "jsonName": "sx126xRxBoostedGain",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "override_frequency",
      "jsonName": "overrideFrequency",
      "kind": "float",
      "repeated": false
    },
    {
      "name": "pa_fan_disabled",
      "jsonName": "paFanDisabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "ignore_incoming",
      "jsonName": "ignoreIncoming",
      "kind": "uint",
      "repeated": true,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "ignore_mqtt",
      "jsonName": "ignoreMqtt",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "config_ok_to_mqtt",
      "jsonName": "configOkToMqtt",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "fem_lna_mode",
      "jsonName": "femLnaMode",
      "kind": "enum",
      "repeated": false,
      "enumType": "FEM_LNA_Mode"
    },
    {
      "name": "serial_hal_only",
      "jsonName": "serialHalOnly",
      "kind": "bool",
      "repeated": false
    }
  ],
  "bluetooth": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "mode",
      "jsonName": "mode",
      "kind": "enum",
      "repeated": false,
      "enumType": "PairingMode"
    },
    {
      "name": "fixed_pin",
      "jsonName": "fixedPin",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    }
  ],
  "security": [
    {
      "name": "public_key",
      "jsonName": "publicKey",
      "kind": "bytes",
      "repeated": false
    },
    {
      "name": "private_key",
      "jsonName": "privateKey",
      "kind": "bytes",
      "repeated": false
    },
    {
      "name": "admin_key",
      "jsonName": "adminKey",
      "kind": "bytes",
      "repeated": true
    },
    {
      "name": "is_managed",
      "jsonName": "isManaged",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "serial_enabled",
      "jsonName": "serialEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "debug_log_api_enabled",
      "jsonName": "debugLogApiEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "admin_channel_enabled",
      "jsonName": "adminChannelEnabled",
      "kind": "bool",
      "repeated": false
    }
  ],
  "sessionkey": [],
  "device_ui": [
    {
      "name": "version",
      "jsonName": "version",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "screen_brightness",
      "jsonName": "screenBrightness",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "screen_timeout",
      "jsonName": "screenTimeout",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "screen_lock",
      "jsonName": "screenLock",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "settings_lock",
      "jsonName": "settingsLock",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "pin_code",
      "jsonName": "pinCode",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "theme",
      "jsonName": "theme",
      "kind": "enum",
      "repeated": false,
      "enumType": "Theme"
    },
    {
      "name": "alert_enabled",
      "jsonName": "alertEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "banner_enabled",
      "jsonName": "bannerEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "ring_tone_id",
      "jsonName": "ringToneId",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "language",
      "jsonName": "language",
      "kind": "enum",
      "repeated": false,
      "enumType": "Language"
    },
    {
      "name": "node_filter",
      "jsonName": "nodeFilter",
      "kind": "message",
      "repeated": false,
      "messageType": "NodeFilter"
    },
    {
      "name": "node_highlight",
      "jsonName": "nodeHighlight",
      "kind": "message",
      "repeated": false,
      "messageType": "NodeHighlight"
    },
    {
      "name": "calibration_data",
      "jsonName": "calibrationData",
      "kind": "bytes",
      "repeated": false
    },
    {
      "name": "map_data",
      "jsonName": "mapData",
      "kind": "message",
      "repeated": false,
      "messageType": "Map"
    },
    {
      "name": "compass_mode",
      "jsonName": "compassMode",
      "kind": "enum",
      "repeated": false,
      "enumType": "CompassMode"
    },
    {
      "name": "screen_rgb_color",
      "jsonName": "screenRgbColor",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "is_clockface_analog",
      "jsonName": "isClockfaceAnalog",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "gps_format",
      "jsonName": "gpsFormat",
      "kind": "enum",
      "repeated": false,
      "enumType": "GpsCoordinateFormat"
    }
  ]
};

export const MESHTASTIC_MODULE_SECTIONS: Readonly<Record<string, readonly MeshtasticField[]>> = {
  "mqtt": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "address",
      "jsonName": "address",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "username",
      "jsonName": "username",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "password",
      "jsonName": "password",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "encryption_enabled",
      "jsonName": "encryptionEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "json_enabled",
      "jsonName": "jsonEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "tls_enabled",
      "jsonName": "tlsEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "root",
      "jsonName": "root",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "proxy_to_client_enabled",
      "jsonName": "proxyToClientEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "map_reporting_enabled",
      "jsonName": "mapReportingEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "map_report_settings",
      "jsonName": "mapReportSettings",
      "kind": "message",
      "repeated": false,
      "messageType": "MapReportSettings"
    }
  ],
  "serial": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "echo",
      "jsonName": "echo",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "rxd",
      "jsonName": "rxd",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "txd",
      "jsonName": "txd",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "baud",
      "jsonName": "baud",
      "kind": "enum",
      "repeated": false,
      "enumType": "Serial_Baud"
    },
    {
      "name": "timeout",
      "jsonName": "timeout",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "mode",
      "jsonName": "mode",
      "kind": "enum",
      "repeated": false,
      "enumType": "Serial_Mode"
    },
    {
      "name": "override_console_serial_port",
      "jsonName": "overrideConsoleSerialPort",
      "kind": "bool",
      "repeated": false
    }
  ],
  "external_notification": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "output_ms",
      "jsonName": "outputMs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "output",
      "jsonName": "output",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "output_vibra",
      "jsonName": "outputVibra",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "output_buzzer",
      "jsonName": "outputBuzzer",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "active",
      "jsonName": "active",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "alert_message",
      "jsonName": "alertMessage",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "alert_message_vibra",
      "jsonName": "alertMessageVibra",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "alert_message_buzzer",
      "jsonName": "alertMessageBuzzer",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "alert_bell",
      "jsonName": "alertBell",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "alert_bell_vibra",
      "jsonName": "alertBellVibra",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "alert_bell_buzzer",
      "jsonName": "alertBellBuzzer",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "use_pwm",
      "jsonName": "usePwm",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "nag_timeout",
      "jsonName": "nagTimeout",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "use_i2s_as_buzzer",
      "jsonName": "useI2sAsBuzzer",
      "kind": "bool",
      "repeated": false
    }
  ],
  "store_forward": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "heartbeat",
      "jsonName": "heartbeat",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "records",
      "jsonName": "records",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "history_return_max",
      "jsonName": "historyReturnMax",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "history_return_window",
      "jsonName": "historyReturnWindow",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "is_server",
      "jsonName": "isServer",
      "kind": "bool",
      "repeated": false
    }
  ],
  "range_test": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "sender",
      "jsonName": "sender",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "save",
      "jsonName": "save",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "clear_on_reboot",
      "jsonName": "clearOnReboot",
      "kind": "bool",
      "repeated": false
    }
  ],
  "telemetry": [
    {
      "name": "device_update_interval",
      "jsonName": "deviceUpdateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "environment_update_interval",
      "jsonName": "environmentUpdateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "environment_measurement_enabled",
      "jsonName": "environmentMeasurementEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "environment_screen_enabled",
      "jsonName": "environmentScreenEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "environment_display_fahrenheit",
      "jsonName": "environmentDisplayFahrenheit",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "air_quality_enabled",
      "jsonName": "airQualityEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "air_quality_interval",
      "jsonName": "airQualityInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "power_measurement_enabled",
      "jsonName": "powerMeasurementEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "power_update_interval",
      "jsonName": "powerUpdateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "power_screen_enabled",
      "jsonName": "powerScreenEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "health_measurement_enabled",
      "jsonName": "healthMeasurementEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "health_update_interval",
      "jsonName": "healthUpdateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "health_screen_enabled",
      "jsonName": "healthScreenEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "device_telemetry_enabled",
      "jsonName": "deviceTelemetryEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "air_quality_screen_enabled",
      "jsonName": "airQualityScreenEnabled",
      "kind": "bool",
      "repeated": false
    }
  ],
  "canned_message": [
    {
      "name": "rotary1_enabled",
      "jsonName": "rotary1Enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "inputbroker_pin_a",
      "jsonName": "inputbrokerPinA",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "inputbroker_pin_b",
      "jsonName": "inputbrokerPinB",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "inputbroker_pin_press",
      "jsonName": "inputbrokerPinPress",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "inputbroker_event_cw",
      "jsonName": "inputbrokerEventCw",
      "kind": "enum",
      "repeated": false,
      "enumType": "InputEventChar"
    },
    {
      "name": "inputbroker_event_ccw",
      "jsonName": "inputbrokerEventCcw",
      "kind": "enum",
      "repeated": false,
      "enumType": "InputEventChar"
    },
    {
      "name": "inputbroker_event_press",
      "jsonName": "inputbrokerEventPress",
      "kind": "enum",
      "repeated": false,
      "enumType": "InputEventChar"
    },
    {
      "name": "updown1_enabled",
      "jsonName": "updown1Enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "allow_input_source",
      "jsonName": "allowInputSource",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "send_bell",
      "jsonName": "sendBell",
      "kind": "bool",
      "repeated": false
    }
  ],
  "audio": [
    {
      "name": "codec2_enabled",
      "jsonName": "codec2Enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "ptt_pin",
      "jsonName": "pttPin",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "bitrate",
      "jsonName": "bitrate",
      "kind": "enum",
      "repeated": false,
      "enumType": "Audio_Baud"
    },
    {
      "name": "i2s_ws",
      "jsonName": "i2sWs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "i2s_sd",
      "jsonName": "i2sSd",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "i2s_din",
      "jsonName": "i2sDin",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "i2s_sck",
      "jsonName": "i2sSck",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    }
  ],
  "remote_hardware": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "allow_undefined_pin_access",
      "jsonName": "allowUndefinedPinAccess",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "available_pins",
      "jsonName": "availablePins",
      "kind": "message",
      "repeated": true,
      "messageType": "RemoteHardwarePin"
    }
  ],
  "neighbor_info": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "update_interval",
      "jsonName": "updateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "transmit_over_lora",
      "jsonName": "transmitOverLora",
      "kind": "bool",
      "repeated": false
    }
  ],
  "ambient_lighting": [
    {
      "name": "led_state",
      "jsonName": "ledState",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "current",
      "jsonName": "current",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "red",
      "jsonName": "red",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "green",
      "jsonName": "green",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "blue",
      "jsonName": "blue",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    }
  ],
  "detection_sensor": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "minimum_broadcast_secs",
      "jsonName": "minimumBroadcastSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "state_broadcast_secs",
      "jsonName": "stateBroadcastSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "send_bell",
      "jsonName": "sendBell",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "name",
      "jsonName": "name",
      "kind": "string",
      "repeated": false
    },
    {
      "name": "monitor_pin",
      "jsonName": "monitorPin",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "detection_trigger_type",
      "jsonName": "detectionTriggerType",
      "kind": "enum",
      "repeated": false,
      "enumType": "TriggerType"
    },
    {
      "name": "use_pullup",
      "jsonName": "usePullup",
      "kind": "bool",
      "repeated": false
    }
  ],
  "paxcounter": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "paxcounter_update_interval",
      "jsonName": "paxcounterUpdateInterval",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "wifi_threshold",
      "jsonName": "wifiThreshold",
      "kind": "int",
      "repeated": false,
      "min": -2147483648,
      "max": 2147483647
    },
    {
      "name": "ble_threshold",
      "jsonName": "bleThreshold",
      "kind": "int",
      "repeated": false,
      "min": -2147483648,
      "max": 2147483647
    }
  ],
  "statusmessage": [
    {
      "name": "node_status",
      "jsonName": "nodeStatus",
      "kind": "string",
      "repeated": false
    }
  ],
  "traffic_management": [
    {
      "name": "enabled",
      "jsonName": "enabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "position_dedup_enabled",
      "jsonName": "positionDedupEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "position_precision_bits",
      "jsonName": "positionPrecisionBits",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "position_min_interval_secs",
      "jsonName": "positionMinIntervalSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "nodeinfo_direct_response",
      "jsonName": "nodeinfoDirectResponse",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "nodeinfo_direct_response_max_hops",
      "jsonName": "nodeinfoDirectResponseMaxHops",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "rate_limit_enabled",
      "jsonName": "rateLimitEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "rate_limit_window_secs",
      "jsonName": "rateLimitWindowSecs",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "rate_limit_max_packets",
      "jsonName": "rateLimitMaxPackets",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "drop_unknown_enabled",
      "jsonName": "dropUnknownEnabled",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "unknown_packet_threshold",
      "jsonName": "unknownPacketThreshold",
      "kind": "uint",
      "repeated": false,
      "min": 0,
      "max": 4294967295
    },
    {
      "name": "exhaust_hop_telemetry",
      "jsonName": "exhaustHopTelemetry",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "exhaust_hop_position",
      "jsonName": "exhaustHopPosition",
      "kind": "bool",
      "repeated": false
    },
    {
      "name": "router_preserve_hops",
      "jsonName": "routerPreserveHops",
      "kind": "bool",
      "repeated": false
    }
  ],
  "tak": [
    {
      "name": "team",
      "jsonName": "team",
      "kind": "enum",
      "repeated": false,
      "enumType": "Team"
    },
    {
      "name": "role",
      "jsonName": "role",
      "kind": "enum",
      "repeated": false,
      "enumType": "MemberRole"
    }
  ]
};

export const MESHTASTIC_CHANNEL_FIELDS: readonly MeshtasticField[] = [
  {
    "name": "channel_num",
    "jsonName": "channelNum",
    "kind": "uint",
    "repeated": false,
    "min": 0,
    "max": 4294967295
  },
  {
    "name": "psk",
    "jsonName": "psk",
    "kind": "bytes",
    "repeated": false
  },
  {
    "name": "name",
    "jsonName": "name",
    "kind": "string",
    "repeated": false
  },
  {
    "name": "id",
    "jsonName": "id",
    "kind": "uint",
    "repeated": false,
    "min": 0,
    "max": 4294967295
  },
  {
    "name": "uplink_enabled",
    "jsonName": "uplinkEnabled",
    "kind": "bool",
    "repeated": false
  },
  {
    "name": "downlink_enabled",
    "jsonName": "downlinkEnabled",
    "kind": "bool",
    "repeated": false
  },
  {
    "name": "module_settings",
    "jsonName": "moduleSettings",
    "kind": "message",
    "repeated": false,
    "messageType": "ModuleSettings"
  },
  {
    "name": "index",
    "jsonName": "index",
    "kind": "int",
    "repeated": false,
    "min": -2147483648,
    "max": 2147483647
  },
  {
    "name": "settings",
    "jsonName": "settings",
    "kind": "message",
    "repeated": false,
    "messageType": "ChannelSettings"
  },
  {
    "name": "role",
    "jsonName": "role",
    "kind": "enum",
    "repeated": false,
    "enumType": "Channel_Role"
  }
];

export const MESHTASTIC_SCHEMA_SOURCE_VERSION = "2.7.11";
